const BereavmentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#044acc"
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#fff"
      fillOpacity={0.9}
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#044acc"
      fillRule="evenodd"
      d="M30.093 20.998a7.51 7.51 0 0 0-10.823-.057c-3.005 3.054-3.03 8.033-.056 11.119L32 45.333 44.786 32.06c2.974-3.086 2.948-8.065-.056-11.12a7.51 7.51 0 0 0-10.823.058L32 22.978l-1.907-1.98ZM32 41.73l10.986-11.404c2.034-2.112 2.016-5.544-.038-7.632a5.01 5.01 0 0 0-7.24.039L32 26.582l-3.708-3.85a5.01 5.01 0 0 0-7.24-.038c-2.054 2.088-2.072 5.52-.038 7.632L32 41.73Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillOpacity={0.4}
      fillRule="evenodd"
      d="M30.093 20.998a7.51 7.51 0 0 0-10.823-.057c-3.005 3.054-3.03 8.033-.056 11.119L32 45.333 44.786 32.06c2.974-3.086 2.948-8.065-.056-11.12a7.51 7.51 0 0 0-10.823.058L32 22.978l-1.907-1.98ZM32 41.73l10.986-11.404c2.034-2.112 2.016-5.544-.038-7.632a5.01 5.01 0 0 0-7.24.039L32 26.582l-3.708-3.85a5.01 5.01 0 0 0-7.24-.038c-2.054 2.088-2.072 5.52-.038 7.632L32 41.73Z"
      clipRule="evenodd"
    />
  </svg>
);
export default BereavmentIcon;
